// extracted by mini-css-extract-plugin
module.exports = {"Button":"CompanyButton_Button__2pp5_","ButtonOutline":"CompanyButton_ButtonOutline__roO1e","IsWhite":"CompanyButton_IsWhite__3Hnz3"};